"use strict";

class CartofferList extends HTMLElement {
    constructor(){
        super();

        this.clickSourceElement = null;
        this.selectors = this.selectors || {};
        this.selectors.offerSections = this.querySelectorAll('.offerSection');
        const collections = {};
        this.selectors.offerSections.forEach(section => {
            const collectionData = JSON.parse(section.querySelector('script[type="application/json"]').textContent);
            collections[collectionData.type] = {...collectionData, isAllLoaded: false, currentPage: 0, totalPages: 0, section};
        });

        this.state = {
            activeBtn: null,
            isLoading: false,
            collections,
            activeCollection: null,
            maxProducts: 10
        };

        this.isCartPage = document.querySelector('body.template-cart');
        this.buildSelectors();
        this.init();
    }

    static get getElementName(){
        return 'cart-offer-list'
    }

    buildSelectors(){
        this.selectors.modelClose = this.querySelector('.sideoofers-close');
        this.selectors.offerForms = this.querySelectorAll('form.cart-offer-product-form');
        this.selectors.backSection = this.querySelector('.cart-offer-back');
        this.selectors.loadMoreBtn = this.querySelector('[data-load-more-btn]');
    }

    init(){
        this.selectors.modelClose.addEventListener('click', this.hide.bind(this));

        this.selectors.backSection.addEventListener('click', this.hide.bind(this));

        const throttleFn = _theme.Helpers.throttle((entries, observer) => {
            const isIntersecting = entries[0].isIntersecting;
            if(this.state.isLoading || !isIntersecting) return;
            
            if(!this.state.activeCollection) return;

            if(this.state.activeCollection.isAllLoaded){
                return;
            }

            const isAllLoaded = Object.keys(this.state.collections).every(key => this.state.collections[key].isAllLoaded);
            if(isAllLoaded){
                observer.unobserve(entries[0].target);
                return;
            }

            const startIndex = this.state.activeCollection.currentPage * this.state.maxProducts; // if 1 then 1-1*10 = 0, 2-1*10 = 10
            this.loadProductsFromSearchanize(
                this.state.activeCollection.handle,
                startIndex,
                this.state.activeCollection.type,
            );
        });

        const observerIns = new IntersectionObserver(throttleFn, {
            root: this.querySelector('aside'),
            rootMargin: '0px 0px 0px 0px',
            threshold: 0.05
        });

        observerIns.observe(this.selectors.loadMoreBtn);

        Object.keys(this.state.collections).forEach(key => {
            this.loadProductsFromSearchanize(this.state.collections[key].handle, 0, this.state.collections[key].type);
        });
    }

    initProductEvents(){
        const variantSelectors = this.querySelectorAll('.offer-variant-size-container select[name="id"]');

        variantSelectors.forEach(selectNode => {
            selectNode.addEventListener('change', evt => {
                try {
                    const form = selectNode.closest('form');
                    const quickview = form.querySelector('cart-offer-quickview');
                    const parent = selectNode.closest('.cart-offer.grid-item');
                    const variantJSONScript = form.querySelector('script[type="application/json"]');
                    const variant = JSON.parse(variantJSONScript.textContent)[selectNode.value];
                    const salePriceElem = parent.querySelector('[data-sale-price]');
                    const salePriceElemSrOnly = parent.querySelector('[data-sale-price-sr-only]');
                    const comparePriceElem = parent.querySelector('[data-compare-price]');
                    const comparePriceElemSrOnly = parent.querySelector('[data-compare-price-sr-only]');
                    const saleElems = [salePriceElem, salePriceElemSrOnly];
                    const compareElems = [comparePriceElem, comparePriceElemSrOnly];

                    if(quickview) {
                        quickview.setAttribute('data-id', variant.id);
                        quickview.variantId = variant.id;
                    }

                    if(Number(variant.price)){
                        saleElems.forEach(elem => elem.classList.remove('hidden'));
                        salePriceElem.textContent = _theme.Helpers.formatPrice(variant.price);
                        salePriceElemSrOnly.textContent = `Sale Price ${_theme.Helpers.formatPrice(variant.price)}`
                    } else {
                        saleElems.forEach(elem => elem.classList.add('hidden'));
                    }

                    if(Number(variant.compareAtPrice)){
                        compareElems.forEach(elem => elem.classList.remove('hidden'));
                        comparePriceElem.textContent = _theme.Helpers.formatPrice(variant.compareAtPrice);
                        comparePriceElemSrOnly.textContent = `Original Price ${_theme.Helpers.formatPrice(variant.compareAtPrice)}`
                    } else {
                        compareElems.forEach(elem => elem.classList.add('hidden'));
                    }
                } catch (error) {
                    console.log(error);
                }
            });
        });
    }

    show(type, clickSourceElement){
        this.clickSourceElement = clickSourceElement;
        this.state.activeCollection = this.state.collections[type];
        if(!this.state.activeCollection) return;

        document.body.classList.add('overflow-hidden');
        this.selectors.offerSections.forEach(section => {
            const tag = section.dataset.tag.trim();
            if(tag === type) section.setAttribute('aria-hidden', false);
            else section.setAttribute('aria-hidden', true);
        });

        this.setAttribute('data-type', type);
        this.setAttribute('aria-hidden', false);
        this.classList.add('active');
        if(this.state.collections[type] != undefined){
          this.state.activeCollection = this.state.collections[type]
        }

        if(this.state.activeCollection.all_products_count < 10){
            this.state.activeCollection.isAllLoaded = true;
        }

        const cart_active = document.querySelector('.cart-show');    
        const wrapper_overlay_selector = document.querySelector('.wrapper-overlay');
        if(cart_active){
           wrapper_overlay_selector.classList.remove('active');   
        }

        const cart_offer_list = document.querySelector('cart-offer-list');    
        if(cart_offer_list){
           cart_offer_list.classList.add('active');   
        }

    }

    hide(){
        document.body.classList.remove('overflow-hidden');
        this.setAttribute('aria-hidden', true);
        this.classList.remove('active');
        $('*').not($('.cart-offer-container').find('*')).not('.cart-offer-container').not($('.cart-offer-container').parents()).removeAttr('aria-hidden','true');
        this.removeAttribute('data-type');
        this.selectors.offerSections.forEach(section => {
            section.setAttribute('aria-hidden', true);
        });
        this.state.activeCollection = null;
        if(this.clickSourceElement) {
            this.clickSourceElement.focus();
            this.clickSourceElement = null;
        }
        const cart_active = document.querySelector('.cart-show');    
        const wrapper_overlay_selector = document.querySelector('.wrapper-overlay');
        if(cart_active){
           wrapper_overlay_selector.classList.add('active');   
        }
    }

    async loadProductsFromSearchanize(handle, startIndex, type){
        try {
            this.toggleInfiniteLoader(true);
            const resp = await fetch(`https://www.searchanise.com/getresults?api_key=3R1z2i6V5n&output=jsonp&items=true&facets=false&facetsShowUnavailableOptions=false&categories=true&sortBy=sales_amount&sortOrder=desc&collection=${handle}&maxResults=${this.state.maxProducts}&startIndex=${startIndex}`);
            const result = await resp.json();
            this.renderProducts(result, type);
            this.state.collections[type].currentPage = this.state.collections[type].currentPage + 1;
            this.initProductEvents();
            this.toggleInfiniteLoader(false);
        } catch (error) {
            console.error('Error', error);
        }
    }

    renderProducts(result, type){
        const collection = this.state.collections[type];
        if(!result || result.totalItems === 0) {
            this.state.collections[type].isAllLoaded = true;
            return;
        }

        let mainHtml = '';
        result.items.forEach((product, index) => {
            // Check if product has offer metafield (applicable_offer)
            const productOffer = product.metafield_b9ba57cd478d42c60429674e481c50c1;

            if (productOffer) {
                // Check if any variant has is_offer_applicable = true AND is in stock
                const hasOfferVariantInStock = product.shopify_variants?.some(
                    (variant) => variant.search_variant_metafields_data?.variant_metafield_25c7b979d6abf42fb11a9be16739134f === 'true' && variant.available !== '0'
                );

                // Skip this product if no offer variant is in stock
                if (!hasOfferVariantInStock) {
                    return;
                }
            }

            let product_html = _theme.product_html.cartOfferGrid;
            const offerVariant = this.getApplicableVariant(product);
            if(!offerVariant) return false;

            const prodType = product?.metafield_9e14d49086f4ac1134f463aa2738d80e ?? '';
            const productHandle = product.link ? product.link.split('/').pop() : '';
            
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Id]]', product.product_id);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Type]]', prodType);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Handle]]', productHandle);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Title]]', product.title);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_URL]]', offerVariant.link || product.link);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Images]]', this.buildImagesHtml(product));
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Vendor]]', this.buildVendorHtml(product));
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Price]]', this.buildPriceHtml(offerVariant));
            product_html = _theme.Helpers.updateHtml(product_html, '[[Variant_Id]]', offerVariant.variant_id);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Variant_Size]]', this.buildVariantSelectorHtml(product, collection.render_variants));
            product_html = _theme.Helpers.updateHtml(product_html, '[[GWP_Properties_Cart]]', this.buildGwpProperties(product));
            mainHtml += product_html;
        });

        this.selectors.offerSections.forEach(section => {
            const sectionType = section.dataset.tag;
            if(sectionType === type){
                const productsContainer = section.querySelector('.offerCollection');
                const oldHtml = productsContainer.innerHTML;
                productsContainer.innerHTML = oldHtml + mainHtml;        
            }
        });
    }

    buildGwpProperties(product) {
        let html = '';
        if (!product) return;

        // Check if any variant has the metafield structure first
        const hasMetafieldStructure = product.shopify_variants?.some((variant) =>
            variant.search_variant_metafields_data?.hasOwnProperty('variant_metafield_25c7b979d6abf42fb11a9be16739134f')
        );

        if (hasMetafieldStructure) {
            // Find variant with is_offer_applicable = true
            const offerVariant = product.shopify_variants?.find(
                v => v.search_variant_metafields_data?.variant_metafield_25c7b979d6abf42fb11a9be16739134f === 'true'
            );

            if (offerVariant && offerVariant.variant_id) {
                html += `<input type="hidden" name="properties[_bundleVarId]" value="${offerVariant.variant_id}" data-bundleVarId>`;
            }
        }
        return html;
    }

    buildImagesHtml(product){
        if(!product) return '';
        if(!product.shopify_images) product.shopify_images = ["data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="];

        let html = '';
        if(!product.shopify_images && product.shopify_images.length === 0) return html;
        if (product.shopify_images.length < 2) {
            product.shopify_images.push(product.shopify_images[0]);
            if (product.shopify_images_alt && product.shopify_images_alt.length === 1) {
                product.shopify_images_alt.push(product.shopify_images_alt[0]);
            }
        }
        product.shopify_images.slice(0,2).forEach((imageUrl, index) => {
            const imgUrl = imageUrl.includes('data:image/') ? imageUrl : `${imageUrl}&width=300`;
            const imageAlt = (product.shopify_images_alt && product.shopify_images_alt[index]) || product.title;
            
            html += `<div class="product-image image-alter" ${index === 1 ? 'aria-hidden="true"': ''}>
                <div class="image-${index+1}">
                    <span>
                        <img
                            src="${imgUrl}"
                            alt="${imageAlt}"
                            width="300"
                            height="300"
                            sizes="(min-width: 400px) 160px, 300px"
                            style="width: 160px;"
                        />
                    </span>
                </div>
            </div>`
        });

        return html;
    }

    buildVendorHtml(product){
        if(!product.vendor) return '';
        const html = `<span>${product.vendor}</span>`; // href="/collections/${_theme.Helpers.handleize(product.vendor)}"
        return html;
    }

    buildPriceHtml(variant){
        const price = _theme.Helpers.formatPrice(variant.price);
        const compareAtPrice = variant.list_price ? _theme.Helpers.formatPrice(variant.list_price) : null;
        let html = `<div class="priceRange"><span data-sale-price-sr-only class="visually-hidden">Sale Price ${price}</span><span data-sale-price aria-hidden="true">${price}</span>`;
        if(compareAtPrice){
            html += `<span data-compare-price-sr-only class="visually-hidden">Original Price ${compareAtPrice}</span><span data-compare-price aria-hidden="true" class="stike-through">${compareAtPrice}</span>`
        }
        html += '</div>';

        return html;
    }

    buildVariantSelectorHtml(product, render_variants){
        if(!product) return '';

        let html = '';
        
        // Filter variants that have is_offer_applicable = true and are available
        const offerVariants = product.shopify_variants?.filter(
            (variant) => variant.search_variant_metafields_data?.variant_metafield_25c7b979d6abf42fb11a9be16739134f === 'true' && variant.available !== '0'
        ) || [];

        const hasMultiOfferVariants = offerVariants.length > 1;

        // If multiple offer variants exist, show dropdown
        if(render_variants && hasMultiOfferVariants) {
            const randomIdSuffix = `${new Date().getTime()}-${Math.floor(Math.random()*9999)}`;
            const selectId = `size-select-${product.product_id}-${randomIdSuffix}`;
            html = `<div class="offer-variant-size-container"><label for="${selectId}" class="sr-only">Select Size</label><select name="id" id="${selectId}">`;
            const variantData = {};
            offerVariants.forEach(variant => {
                variantData[variant.variant_id] = {"id": variant.variant_id, "price": variant.price, "compareAtPrice": variant.list_price, "link": variant.link};
                const key = Object.keys(variant.options)[0];
                html += `<option value="${variant.variant_id}">${variant.options[key]}</option>`;
            });
            html += `</select></div>`;
            html += `<script type="application/json">${JSON.stringify(variantData)}</script>`;
        } else {
            // Single offer variant - show directly
            if(offerVariants.length > 0) {
                const offerVariant = offerVariants[0];
                const optionName = Object.keys(offerVariant?.options || {})[0];
                html = `<div class="offer-variant-size-container"><input type="hidden" name="id" value="${offerVariant.variant_id}" /><div class="offer-variant-size">${optionName}: ${offerVariant?.options[optionName]}</div></div>`;
            }
        }

        return html;
    }

    getApplicableVariant(product){
        // Check if any variant has the metafield structure first
        const hasMetafieldStructure = product.shopify_variants?.some((variant) =>
            variant.search_variant_metafields_data?.hasOwnProperty('variant_metafield_25c7b979d6abf42fb11a9be16739134f')
        );

        if (hasMetafieldStructure) {
            // Find variant with is_offer_applicable = true that is available
            const bundleIdVariant = product.shopify_variants.find(
                (variant) => variant.search_variant_metafields_data?.variant_metafield_25c7b979d6abf42fb11a9be16739134f === 'true' && variant.available !== '0'
            );

            // Find the first variant that is available (not "0")
            const availableVariant = product.shopify_variants.find(
                (variant) => variant.available !== '0'
            );

            return bundleIdVariant || availableVariant || product.shopify_variants[0];
        } else {
            // Find the first variant that is available (not "0")
            const availableVariant = product.shopify_variants.find(
                (variant) => variant.available !== '0'
            );

            // If no variant is available, return the first variant
            return availableVariant || product.shopify_variants[0];
        }
    }

    toggleInfiniteLoader(show){
        const loader = this.selectors.loadMoreBtn.querySelector('[data-custom-loader]');
        if(show){
            loader.classList.remove('hidden');
        } else {
            loader.classList.add('hidden');
        }
    }
}

class CartOfferBtn extends HTMLElement {
    constructor(){
        super();
        this.cartOffer = document.querySelector('cart-offer-list');
        this.offerBtn = this.querySelector('button');
        this.handleShowModel = this.showModel.bind(this);
    }

    static get getElementName(){
        return 'cart-offer-btn'
    }

    connectedCallback(){ 
        if(this.offerBtn){
            this.offerBtn.addEventListener('click', this.handleShowModel);
        }
    }

    disconnectedCallback(){
        if(this.offerBtn){
            this.offerBtn.removeEventListener('click', this.handleShowModel);
        }
    }
    
    showModel(evt){
        evt.preventDefault();
        const type = this.offerBtn.dataset.type;
        if(!type) return;
        this.cartOffer.show(type.trim(), this.offerBtn);

        _theme.focusTrap($('.cart-offer-container'))
        $('*').not($('.cart-offer-container').find('*')).not('.cart-offer-container').not($('.cart-offer-container').parents()).attr('aria-hidden','true');
    }
}

class ATCForm extends HTMLElement {
    constructor(){
        super();
        this.cartOffer = document.querySelector('cart-offer-list');
        this.form = this.querySelector('form');
        this.handleFormSubmit = this.onFormSubmit.bind(this);
    }

    static get getElementName(){
        return 'atc-form'
    }

    connectedCallback(){
        this.form.addEventListener('submit', this.handleFormSubmit);
    }

    disconnectedCallback(){
        this.form.removeEventListener('submit', this.handleFormSubmit);
    }
    
    onFormSubmit(evt){
        evt.preventDefault();
        const vid = this.form.querySelector('[name="id"]').value;
        if(!vid) return;
    
        const loader = this.form.querySelector('[data-custom-loader]');
        this.cartOffer.setAttribute('data-loading', true);
        this.form.setAttribute('data-loading', true);
        loader.classList.remove('hidden');
        this.form.disabled = true;
        
        // Do Not Remove Code - Add Properties for GWP Discount
        let properties = {};
        let bundleVarIdElement = this.form.querySelector("[data-bundleVarId]");
        if (bundleVarIdElement) {
            properties["_bundleVarId"] = bundleVarIdElement.value || null;
        }
        // Do Not Remove Code - Add Properties for GWP Discount
        
        _theme.Helpers.addProductToCart(vid,1, properties, (resp) => {
            if(this.cartOffer.isCartPage){
                _theme.Cart.cartMapData(resp, () => {
                    this.atcCallback(false);
                });
            } else {
                _theme.MiniCart.lineItemChangeCallBack(resp, () => {
                    this.atcCallback(true);
                });
            }
        }, (err) => {
            console.error(err);
            this.atcCallback(false, true);
        }, true);
    }

    atcCallback(showMiniCart, hasError) {
        const loader = this.form.querySelector('[data-custom-loader]');
        this.form.disabled = false;
        this.form.removeAttribute('data-loading');
        this.cartOffer.removeAttribute('data-loading');
        loader.classList.add('hidden');
        if(!hasError){
            this.cartOffer.hide();
            if(showMiniCart) _theme.toggleSideCart(1, null, true);
        }
    }
}

class CartOfferGriditemQuickview extends HTMLElement {
    constructor(){
        super();
        const form = this.closest('form');
        if(!form) return;
        this.handleProductGridClick = this.onProductGridClick.bind(this);
        this.variantId = form.querySelector('form [name="id"]').value;
    }

    static get getElementName(){
        return 'cart-offer-quickview'
    }

    connectedCallback(){
        this.addEventListener('click', this.handleProductGridClick);
    }

    disconnectedCallback(){
        this.removeEventListener('click', this.handleProductGridClick);
    }

    onProductGridClick(evt){
        evt.preventDefault();
        evt.stopPropagation();
        
        const productId = this.dataset.id;
        const productUrl = this.dataset.url;
        if(!productId || !productUrl || !_theme.MiniCartQuickview) return;
    
        _theme.MiniCartQuickview.handleQVClick(productUrl, `qv-${productId}`, this.variantId);
    }
}

 function BackToCart() {
    const closeButton = document.querySelector('.sideoofers-close');
    if(closeButton) closeButton.click();
 }

customElements.define(CartofferList.getElementName, CartofferList);
customElements.define(CartOfferBtn.getElementName, CartOfferBtn);
customElements.define(ATCForm.getElementName, ATCForm);
customElements.define(CartOfferGriditemQuickview.getElementName, CartOfferGriditemQuickview);
